import { api } from '~/api';
import { PricesResponse } from './types';

export interface ProductPricesParams {
  price: number;
  loading: string;
  fromaddr?: string;
  division?: string;
}

export async function fetchProductPrices(
  productId: string,
  params: ProductPricesParams
): Promise<PricesResponse> {
  return api.getData2(`/products/${productId}/displayed-prices`, params);
}

export async function fetchOrderPrices(
  orderId: string
): Promise<PricesResponse> {
  return api.getData2(`/orders/${orderId}/displayed-prices`);
}
